
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuthForms } from '@/hooks/useAuthForms';
import LoadingSubmission from '@/components/auth/LoadingSubmission';
import UpdatePasswordForm from '@/components/auth/UpdatePasswordForm';
import QuickSubmissionForm from '@/components/auth/QuickSubmissionForm';
import AuthTabs from '@/components/auth/AuthTabs';

const Auth = () => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    loading,
    setLoading,
    isCheckingSubmission,
    quickSubmission,
    isResetMode,
    setIsResetMode,
    quickSubmissionId,
    sendMagicLink
  } = useAuthForms();

  // Show loading state while checking submission
  if (isCheckingSubmission) {
    return <LoadingSubmission />;
  }

  // Password reset form after clicking reset link in email
  if (isResetMode) {
    return (
      <UpdatePasswordForm 
        password={password}
        setPassword={setPassword}
        loading={loading}
        setLoading={setLoading}
      />
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-forest">
      <Card className="w-full max-w-md bg-white">
        <CardHeader className="text-center">
          <CardTitle>{quickSubmission ? 'Create Your Account' : 'Welcome to Talento AI'}</CardTitle>
          <CardDescription>
            {quickSubmission 
              ? 'Complete your account setup to track your job application' 
              : 'Sign in to your account or create a new one'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {quickSubmission ? (
            <QuickSubmissionForm 
              email={email}
              setEmail={setEmail}
              loading={loading}
              setLoading={setLoading}
              quickSubmission={quickSubmission}
              quickSubmissionId={quickSubmissionId}
            />
          ) : (
            <AuthTabs 
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              loading={loading}
              setLoading={setLoading}
              isResetMode={isResetMode}
              setIsResetMode={setIsResetMode}
              sendMagicLink={sendMagicLink}
            />
          )}
        </CardContent>
        <CardFooter className="flex justify-center">
          <p className="text-sm text-gray-500">
            By signing up, you agree to our{' '}
            <a href="/terms-and-conditions" className="text-mint hover:underline">
              Terms & Conditions
            </a>
          </p>
        </CardFooter>
      </Card>
    </div>
  );
};

export default Auth;
